import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Footer } from "@/components/Footer";

// Personality: Boutique — large photography, minimal chrome, plenty of air.
const ShopLanding = () => {
  const categories = [
    { name: "Sweatshirts", to: "/shop/sweatshirts", img: "/products/women-hero-group.png" },
    { name: "Mugs", to: "/shop/mugs", img: "/products/elegear-pillowcase-1.png" },
    { name: "Candles", to: "/shop/candles", img: "/products/gaiam-yoga-mat.png" },
    { name: "Tees", to: "/shop/tees", img: "/products/headspace-meditation-book.png" },
  ];
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
      </div>

      <section className="container mx-auto px-6 pt-16 pb-24 text-center max-w-3xl">
        <span className="text-xs uppercase tracking-[0.4em] text-primary">The Shop</span>
        <h1 className="mt-6 text-5xl md:text-8xl leading-[1.02]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
          Small comforts, well-made.
        </h1>
        <p className="mt-8 text-lg text-foreground/70 leading-relaxed">
          A small edit of pieces we actually use ourselves — for cooler nights, warmer mornings, and
          the mood indicator you didn't know you needed.
        </p>
      </section>

      <section className="container mx-auto px-6 pb-32 grid md:grid-cols-2 gap-8">
        {categories.map((c) => (
          <Link key={c.name} to={c.to} className="group block">
            <div className="aspect-[4/5] overflow-hidden bg-muted rounded-sm">
              <img src={c.img} alt={c.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="mt-5 flex items-center justify-between">
              <h3 className="text-3xl" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{c.name}</h3>
              <ArrowRight className="h-5 w-5 text-foreground/50 group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>
        ))}
      </section>

      <section className="container mx-auto px-6 pb-24 text-center">
        <Button asChild size="lg" variant="outline" className="px-10 py-6 text-lg">
          <Link to="/shop"><ShoppingBag className="mr-2 h-5 w-5" /> See everything <ArrowRight className="ml-2 h-5 w-5" /></Link>
        </Button>
      </section>

      <Footer />
    </div>
  );
};
export default ShopLanding;
